import { MarketOverviewByProductId } from '@/creditflowresearch/domain/Product/urlMappings';

export const getMarketOverviewUrl = (productId: string): string | null => {
  return MarketOverviewByProductId[productId] || null;
};
